import { useNavigate } from "react-router-dom";
import PortalLoginForm from "../../components/portal/PortalLoginForm";

const PortalLogin = () => {
    const navigate = useNavigate();

    const loginCompleted = () => {
        navigate("/portal");
    };

    return (
        <>
            <section className="home__query">
                <div className="home__query__content wrap">
                    <h1 className="brochure__title home__query__title">Welcome Aboard</h1>

                    <PortalLoginForm loginComplete={() => loginCompleted()} />
                </div>
            </section>
        </>
    );
};

export default PortalLogin;
